module.exports = __webpack_public_path__ + "static/img/index-5.67de18b1.jpg";